import {Modal} from "react-bootstrap";
import React, {Component, Fragment} from 'react'
import Button from "react-bootstrap/Button";
import classNames from "classnames";

class ModalBase extends Component {

    closeModal = () => {
        const {onHide} = this.props;
        if(onHide)
            onHide();
    }

    setModalShow = () => {
        return this.props.show;
    }

    /**
     * Render the modal component.
     * @returns {React.ReactNode} The modal component.
     */
    render = () => {
        const size = this.getSizeFromProps();
        const baseClassName = this.modalClassname();

        const {className, onHide, onShow, onExit, onExiting} = this.props;
        return (
            <Fragment>
                <Modal show={this.setModalShow()} onHide={onHide} onShow={onShow} onExit={onExit} onExiting={onExiting} centered size={size} className={classNames("modal", baseClassName, className)}>
                    {this.renderHeaderWrapper()}
                    {this.renderBodyWrapper()}
                    {this.renderFooterWrapper()}
                </Modal>
                {this.renderExtraContent()}
            </Fragment>
        );
    };

    renderExtraContent = () => {
    }

    renderHeaderWrapper = () => {
        return (
            <Modal.Header closeButton> {this.renderHeader()} </Modal.Header>
        )
    }

    renderFooterWrapper = () => {
        return (
            <Modal.Footer>{this.renderFooter()}</Modal.Footer>
        )
    }

    renderBodyWrapper = () => {
        return (
            <Modal.Body> {this.renderBody()} </Modal.Body>
        )
    }

    /**
     * Render the header component.
     * @returns {React.ReactNode} The header component of the modal.
     */
    renderHeader = () => {
        const {title, subtitle} = this.props;

        return (
            <React.Fragment>
                <Modal.Title className="title"> Modal heading </Modal.Title>
            </React.Fragment>
        );
    };

    /**
     * Render the components within the body of the modal.
     * @returns {React.ReactNode} The body of the modal.
     */
    renderBody = () => {
    };

    /**
     * Render the footer component.
     * @returns {React.ReactNode} The footer component of the modal.
     */
    renderFooter = () => {
        const {footerText, footerLink} = this.props;

        return (
            <Button onClick={this.props.onHide}>Close</Button>
        );
    };

    /**
     * Returns modal size form props.
     * @returns {string} The size of modal.
     */
    getSizeFromProps = () => {
        const {size, xl, lg, md, sm} = this.props;
        const def = this.defaultSize();

        if (size) return size;
        else if (xl) return "xl";
        else if (lg) return "lg";
        else if (md) return "md";
        else if (sm) return "sm";
        else return def;
    };


    /**
     * Returns default size of modal.
     * @returns {string} The modal size.
     */
    defaultSize = () => "xl";

    /**
     * Returns classname of modal.
     * @returns {string} The classname modal.
     */
    modalClassname = () => "modal-base";

    static defaultProps = {
        headerTitle: "New Video"
    };
}

export default ModalBase;
